<div mat-dialog-title class="dialog-header flex">
    <span>{{ data.title || 'Titre par défaut' }}</span>
    <span class="spacer"></span>
    <mat-icon class="close-button" [mat-dialog-close]="true" tabindex="0" matTooltip="Fermer">close</mat-icon>
</div>
<div mat-dialog-content>
    <!-- Conteneur pour le composant dynamique -->
    @if (data.component) {
    <ng-container>
        <!-- Affiche le composant dynamique -->
        <ng-container #dynamicComponentContainer></ng-container>
    </ng-container>
    }

</div>
@if (data.cancelText||data.confirmText) {
<div mat-dialog-actions>
    @if (data.cancelText) {
    <button mat-button (click)="onNoClick()">{{ data.cancelText }}</button>
    }
    @if (data.confirmText) {
    <button mat-button [mat-dialog-close]="true">{{ data.confirmText}}</button>
    }
</div>
}